export const asObject = (json: Json) => (typeof json === 'object' ? json : {});
